import {
  getActAddressBlockId,
  getActInnLabelBlockId,
  getActOgrnLabelBlockId,
  getActOrganizationNameBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmPmFormAct } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormAct';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import styles from './PmActSubject.module.scss';
import { ErknmSubjectAdd } from './components/PmSubjectInfo';

interface IPmActSubjectProps {
  id: string;
  name: string;
  value: IKnmPmFormAct;
}

export const PmActSubject = ({ id, name, value }: IPmActSubjectProps) => {
  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Сведения о контролируемом лице'} />
      <div className={styles.SubjectAdd}>
        <ErknmSubjectAdd
          id={id}
          name={`${name}.organization`}
          inn={value.organization?.inn}
          innLabelBlockId={getActInnLabelBlockId(id)}
          ogrn={value.organization?.ogrn}
          ogrnLabelBlockId={getActOgrnLabelBlockId(id)}
          organizationNameBlockId={getActOrganizationNameBlockId(id)}
          addressBlockId={getActAddressBlockId(id)}
          checkSubjectResult={value.organization?.checkSubjectResult || null}
          subjectType={value.organization?.subjectTypePm}
          snils={value.organization?.snils}
          ervkId={value.organization?.ervkId}
          inspectionResults={value.organization?.inspectionResults}
        />
      </div>
    </div>
  );
};
